import { Navigate, Route, Routes } from 'react-router'

import { useSession } from './auth/context'
import { Layout } from './components/AppShell'
import { DevicesPage, SettingsPage } from './pages/AppPages'
import { ChangePasswordPage, LoginPage, SignupPage } from './pages/AuthPages'
import { DataPage } from './pages/DataPages'
import { HistoryPage } from './pages/HistoryPage'
import { KasirSettingsPage } from './pages/KasirSettingsPage'
import { LegalPage } from './pages/LegalPages'
import { HomePage, SaleDetailPage, SalesPage } from './pages/ReportPages'
import { SubscriptionPage } from './pages/SubscriptionPage'
import { t } from './strings'

export function App() {
  const { status } = useSession()
  if (status === 'loading') return <p className="center">{t.loading}</p>
  if (status === 'must_change_password') return <ChangePasswordPage />
  if (status === 'anonymous') {
    return (
      <Routes>
        <Route path="/masuk" element={<LoginPage />} />
        <Route path="/daftar" element={<SignupPage />} />
        <Route path="/:doc" element={<LegalPage />} />
        <Route path="*" element={<Navigate to="/masuk" replace />} />
      </Routes>
    )
  }
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="transaksi" element={<SalesPage />} />
        <Route path="transaksi/:id" element={<SaleDetailPage />} />
        <Route path="data" element={<DataPage />} />
        <Route path="hp-kasir" element={<DevicesPage />} />
        <Route path="pengaturan" element={<SettingsPage />} />
        <Route path="pengaturan/kasir" element={<KasirSettingsPage />} />
        <Route path="pengaturan/riwayat" element={<HistoryPage />} />
        <Route path="langganan" element={<SubscriptionPage />} />
      </Route>
      <Route path="/:doc" element={<LegalPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
